import { useGlobalCurrency } from "@/hooks/useGlobalCurrency";
import type { Moneda } from "@/schemas/common";

export function GlobalCurrencySelector() {
	const { currencyPreference, setCurrencyPreference, availableCurrencies } = useGlobalCurrency();

	// Default to PEN if no preference is set yet
	const selectedCurrency = currencyPreference ?? "PEN";

	return (
		<div className="flex items-center space-x-1 overflow-hidden rounded-xl bg-gray-200 p-1 dark:bg-gray-950">
			{(["USD", "PEN", "EUR"] as Moneda[]).map((option) => {
				const isSelected = selectedCurrency === option;
				const isDisabled = !availableCurrencies.includes(option);

				return (
					<button
						key={option}
						type="button"
						disabled={isDisabled}
						onClick={() => setCurrencyPreference(option)}
						className={`rounded-lg px-3.5 py-1.5 text-xs font-medium transition-all focus:z-10 ${
							isSelected
								? "bg-white text-gray-900 shadow-sm ring-1 ring-gray-200 dark:bg-card dark:text-white dark:ring-gray-700"
								: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
						} ${
							isDisabled
								? "cursor-not-allowed opacity-50 hover:text-gray-500 dark:hover:text-slate-400"
								: ""
						}`}
					>
						{option}
					</button>
				);
			})}
		</div>
	);
}
